module.exports = __webpack_public_path__ + "img/GAME_COLORDRAW1.d8c1315f.jpg";